module.exports = __webpack_public_path__ + "static/3d-visual-1-d706b86dc9811b170bef156ca1c2d003.jpeg";